"use strict"
import axios from "axios";
import { getRequest, postRequest } from "@/services/RequestService";

export const getGifts = async () => {
  const base_route = `/birthdays/gifts`;
  const response = await getRequest(`${axios.lpsURL}${base_route}`);
  return response;
}

export const getTier = async () => {
  const base_route = `/tiers`;
  const response = await getRequest(`${axios.lpsURL}${base_route}`);
  return response;
}

export const getGift = async (id) => {
  const base_route = `/birthdays/gifts/${id}/view`;
  const response = await getRequest(`${axios.lpsURL}${base_route}`);
  return response;
}

export const viewNewsletter = async (id) => {
  const base_route = `newsletters/${id}/view`;
  const response = await getRequest(base_route);
  return response;
}

export const getStatisticData = async (extraRequest = null) => {
  const base_route = `/birthdays/gifts/statistics${extraRequest == null ? '' : extraRequest }`;
  const response = await getRequest(`${axios.lpsURL}${base_route}`);
  return response;
}

export const getSelectedGift = async (id, extraRequest = null) => {
  const base_route = `/birthdays/gifts/${id}/selected${extraRequest == null ? '' : extraRequest }`;

  const response = await getRequest(`${axios.lpsURL}${base_route}`);
  return response;
}

export const getRate = async () => {
  const base_route = `/rate/vendor_takaful/earn`;
  const response = await getRequest(`${axios.lpsURL}${base_route}`);
  return response;
}

export const storeGift = async (request) => {
  const base_route = `/birthdays`;
  const response = await postRequest(`${axios.lpsURL}${base_route}`, request);
  return response;
}

export const storeBirthdayGift = async (request) => {
  const base_route = `/birthdays/gifts`;
  const response = await postRequest(`${axios.lpsURL}${base_route}`, request);
  return response;
}

export const storeTier = async (request) => {
  const base_route = `/tiers`;
  const response = await postRequest(`${axios.lpsURL}${base_route}`, request);
  return response;
}

export const updateVendorGift = async (request, id) => {
  const base_route = `/birthdays/gifts/${id}/update`;
  const response = await postRequest(`${axios.lpsURL}${base_route}`, request);
  return response;
}

export const updateGifts = async (request, id) => {
  const base_route = `/birthdays/gifts/approved/${id}/update`;
  const response = await postRequest(`${axios.lpsURL}${base_route}`, request);
  return response;
}

export const activateGift = async (request, id) => {
  const base_route = `/birthdays/gifts/${id}/activate`;
  const response = await postRequest(`${axios.lpsURL}${base_route}`, request);
  return response;
}

export const deactivateGift = async (request, id) => {
  const base_route = `/birthdays/gifts/${id}/deactivate`;
  const response = await postRequest(`${axios.lpsURL}${base_route}`, request);
  return response;
}

export const approveGift = async (request, id) => {
  const base_route = `/birthdays/gifts/${id}/approve`;
  const response = await postRequest(`${axios.lpsURL}${base_route}`, request);
  return response;
}

export const updateNewsletter = async (request, id) => {
  const base_route = `newsletters/${id}/update`;
  const response = await postRequest(base_route, request);
  return response;
}
